import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const deliveryInfoProps = () => ({
  code: {
    type: String,
    required: false,
    default: null
  },
  pdfUrl: {
    type: String,
    required: false,
    default: null
  },
  lieuRetrait: {
    type: String,
    required: false,
    default: null
  }
})

export const useDeliveryInfo = (props) => {

  const { trackEvent } = useInteractionDoneTracking()

  const codeFormatted = computed(() => {
    if (props.code) {
      return props.code.split("-").slice(-1)[0];
    }
    return null;
  })
  const printFile = () => {
    trackEvent({
      actionGA: trackingCodes.ACTIONGA.printTicket,
      categoryGA: trackingCodes.CATEGORYGA.orderConfirmation,
      labelGA: ''
    });
  }

  return { codeFormatted, printFile }
}